import { render } from "./IncomesByGroups.vue?vue&type=template&id=4fa4f436&scoped=true"
import script from "./IncomesByGroups.vue?vue&type=script&lang=js"
export * from "./IncomesByGroups.vue?vue&type=script&lang=js"

import "./IncomesByGroups.vue?vue&type=style&index=0&id=4fa4f436&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa4f436"]])

export default __exports__